import Swal from "sweetalert2";

var dynamicRequest = async (url, method, body) => {
  let myHeaders = new Headers();
  myHeaders.append("Content-Type", "application/json");
  body = JSON.stringify(body);

  let requestOptions = {
    method: method,
    headers: myHeaders,
    body: body,
    redirect: "follow",
  };

  let data;

  await fetch(url, requestOptions)
    .then((response) => response.json())
    .then((result) => {
      typeof result === "object"
        ? (data = result)
        : (data = JSON.parse(result));
    })
    .catch((error) => {
      Swal.fire({
        title: "An error has occurred",
        text: `Error: ${error}}`,
        icon: "error",
        confirmButtonText: "Ok",
      });
    });

  return data;
};

export default {
  dynamicRequest,
};
